import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/yth-logo1.png";

const Footer = () => {
  return (
    // Footer Container: Dark blue gradient for professional look
    <footer className="bg-gradient-to-br from-blue-900 to-blue-950 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* --- Social Media Top Bar --- */}
        <div className="flex flex-col md:flex-row items-center justify-between border-b border-blue-800 pb-8 mb-12">
          <span className="text-blue-200 font-medium mb-4 md:mb-0">
            Connect with us on social networks:
          </span>

          <div className="flex space-x-6">
            {/* Facebook */}
            <a
              href="#!"
              className="text-blue-300 hover:text-white hover:scale-110 transition-all duration-300"
            >
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 320 512"
              >
                <path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
              </svg>
            </a>

            {/* Twitter / X */}
            <a
              href="#!"
              className="text-blue-300 hover:text-white hover:scale-110 transition-all duration-300"
            >
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 512 512"
              >
                <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
              </svg>
            </a>

            {/* Instagram */}
            <a
              href="#!"
              className="text-blue-300 hover:text-white hover:scale-110 transition-all duration-300"
            >
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 448 512"
              >
                <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
              </svg>
            </a>

            {/* LinkedIn */}
            <a
              href="#!"
              className="text-blue-300 hover:text-white hover:scale-110 transition-all duration-300"
            >
              <svg
                className="w-6 h-6"
                fill="currentColor"
                viewBox="0 0 448 512"
              >
                <path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
              </svg>
            </a>
          </div>
        </div>

        {/* --- Main Grid Layout --- */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Column 1: Brand Info */}
          <div>
            <div className="mb-6">
              <img
                className="h-14 w-auto object-contain"
                src={logo}
                alt="Yarqin Tech Hub"
              />
            </div>
            <p className="text-blue-200 text-sm leading-relaxed">
              Yarqin Tech Hub is an innovative institution specializing in web
              development, databases, and technology solutions for government
              agencies and enterprises.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h6 className="text-white font-bold uppercase tracking-wider mb-6 border-l-4 border-blue-500 pl-3">
              Quick Links
            </h6>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/ourteams"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Team
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Departments */}
          <div>
            <h6 className="text-white font-bold uppercase tracking-wider mb-6 border-l-4 border-blue-500 pl-3">
              Departments
            </h6>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/isp"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  ISP Services
                </Link>
              </li>
              <li>
                <Link
                  to="/softwaredevelopment"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Software Dev
                </Link>
              </li>
              <li>
                <Link
                  to="/graphicdesign"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  Graphic Design
                </Link>
              </li>
              <li>
                <Link
                  to="/newspage"
                  className="text-blue-200 hover:text-white transition-colors"
                >
                  News & Updates
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Info */}
          <div>
            <h6 className="text-white font-bold uppercase tracking-wider mb-6 border-l-4 border-blue-500 pl-3">
              Contact Us
            </h6>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-blue-400 mt-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span className="text-blue-200 text-sm">
                  Mazar-e-Sharif, Afghanistan
                </span>
              </div>

              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-blue-400 mt-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
                <a
                  href="mailto:contact@yarqinhub.com"
                  className="text-blue-200 text-sm hover:text-white transition-colors"
                >
                  contact@yarqinhub.com
                </a>
              </div>

              <div className="flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-blue-400 mt-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <a
                  href="tel:+93788414348"
                  className="text-blue-200 text-sm hover:text-white transition-colors"
                >
                  +93 78 841 4348
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- Bottom Copyright Bar --- */}
      <div className="border-t border-blue-900 mt-8 pt-8">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-sm text-blue-400">
          <p>
            © 2026{" "}
            <span className="text-white font-semibold">Yarqin Tech Hub</span>.
            All Rights Reserved.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-6">
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
